module.exports = __webpack_public_path__ + "img/logo_footer.d52c66b9.svg";